// extracted by mini-css-extract-plugin
module.exports = {"zrb":"zrb-3l_SgqvA","footer":"footer-2kgkujl4","commomAd":"commomAd-2YNmNnGp"};